
// @ts-nocheck
import locale__apps_web_locales_ja_ts from "../locales/ja.ts";
import locale__apps_web_locales_en_ts from "../locales/en.ts";


export const localeCodes =  [
  "ja",
  "en"
]

export const localeLoaders = {
  "ja": [{ key: "../locales/ja.ts", load: () => Promise.resolve(locale__apps_web_locales_ja_ts), cache: true }],
  "en": [{ key: "../locales/en.ts", load: () => Promise.resolve(locale__apps_web_locales_en_ts), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ja",
      "name": "JP",
      "language": "ja-JP",
      "files": [
        "/apps/web/locales/ja.ts"
      ]
    },
    {
      "code": "en",
      "name": "US",
      "ios": "en-US",
      "files": [
        "/apps/web/locales/en.ts"
      ]
    }
  ],
  "defaultLocale": "ja",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://s.theckb.com/",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ja",
    "name": "JP",
    "language": "ja-JP",
    "files": [
      {
        "path": "/apps/web/locales/ja.ts"
      }
    ]
  },
  {
    "code": "en",
    "name": "US",
    "ios": "en-US",
    "files": [
      {
        "path": "/apps/web/locales/en.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
